import { Box, FlexProps, Flex, Text } from '@everlywell/ui-kit';
import Price from 'components/Price';
import React from 'react';

export type SimplePurchaseOptionProps = {
  isSelected?: boolean;
  price?: {
    value: number;
    unit: string;
  };
  label: string | React.ReactNode;
  description: string | React.ReactNode;
};

/**
 * [Add the description for what this component does here].
 */
const SimplePurchaseOption = (props: FlexProps & SimplePurchaseOptionProps) => {
  const { isSelected, price, label, description, ...rest } = props;

  const labelElement = typeof label === 'string' ? <Text>{label}</Text> : label;
  const descriptionElement =
    typeof description === 'string' ? (
      <Text size="sm" color="tints.darkGrey">
        {description}
      </Text>
    ) : (
      description
    );

  return (
    <Flex
      as="button"
      background="tints.lightCream"
      borderRadius={'12px'}
      padding={4}
      justifyContent="space-between"
      alignItems={'center'}
      aria-pressed={isSelected}
      width="100%"
      {...rest}
      sx={{
        ...(rest.sx ?? {}),
        ...(isSelected
          ? {
              boxShadow: (theme) =>
                `0px 0px 0px 2px inset ${theme.colors.viridian.base}`,
            }
          : {}),
      }}
    >
      <Box textAlign={'start'}>
        {labelElement}
        {descriptionElement}
      </Box>

      {price && (
        <Box textAlign={'end'}>
          <Price price={price.value} fontWeight={'medium'} />
          <Text size="sm" color="tints.darkGrey">
            {`/ ${price.unit}`}
          </Text>
        </Box>
      )}
    </Flex>
  );
};

export default SimplePurchaseOption;
